export default __webpack_public_path__ + "static/media/backer-mazee.9514f4a8.svg";